/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MailDetails } from '../model';
// @ts-ignore
import type { MailDetailsWithMIME } from '../model';
// @ts-ignore
import type { MailQueueField } from '../model';
/**
 * MPAMailQueueApi - axios parameter creator
 * @export
 */
export const MPAMailQueueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} mailQueueName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerDeleteAllQueuedMail: async (mailQueueName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailQueueName' is not null or undefined
            assertParamExists('mailQueueControllerDeleteAllQueuedMail', 'mailQueueName', mailQueueName)
            const localVarPath = `/api/mpa/mailqueue/deleteAllQueuedMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailQueueName !== undefined) {
                localVarQueryParameter['mailQueueName'] = mailQueueName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {MailQueueField} field 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerDeleteQueuedMail: async (mailQueueName: string, field: MailQueueField, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailQueueName' is not null or undefined
            assertParamExists('mailQueueControllerDeleteQueuedMail', 'mailQueueName', mailQueueName)
            // verify required parameter 'field' is not null or undefined
            assertParamExists('mailQueueControllerDeleteQueuedMail', 'field', field)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('mailQueueControllerDeleteQueuedMail', 'value', value)
            const localVarPath = `/api/mpa/mailqueue/deleteQueuedMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailQueueName !== undefined) {
                localVarQueryParameter['mailQueueName'] = mailQueueName;
            }

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerDeleteQueuedMails: async (mailQueueName: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailQueueName' is not null or undefined
            assertParamExists('mailQueueControllerDeleteQueuedMails', 'mailQueueName', mailQueueName)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mailQueueControllerDeleteQueuedMails', 'requestBody', requestBody)
            const localVarPath = `/api/mpa/mailqueue/deleteQueuedMails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailQueueName !== undefined) {
                localVarQueryParameter['mailQueueName'] = mailQueueName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueueNames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mpa/mailqueue/getQueueNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueueSize: async (mailQueueName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailQueueName' is not null or undefined
            assertParamExists('mailQueueControllerGetQueueSize', 'mailQueueName', mailQueueName)
            const localVarPath = `/api/mpa/mailqueue/getQueueSize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailQueueName !== undefined) {
                localVarQueryParameter['mailQueueName'] = mailQueueName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {string} mailName 
         * @param {boolean} [includeMIME] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueuedMail: async (mailQueueName: string, mailName: string, includeMIME?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailQueueName' is not null or undefined
            assertParamExists('mailQueueControllerGetQueuedMail', 'mailQueueName', mailQueueName)
            // verify required parameter 'mailName' is not null or undefined
            assertParamExists('mailQueueControllerGetQueuedMail', 'mailName', mailName)
            const localVarPath = `/api/mpa/mailqueue/getQueuedMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailQueueName !== undefined) {
                localVarQueryParameter['mailQueueName'] = mailQueueName;
            }

            if (mailName !== undefined) {
                localVarQueryParameter['mailName'] = mailName;
            }

            if (includeMIME !== undefined) {
                localVarQueryParameter['includeMIME'] = includeMIME;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueuedMails: async (mailQueueName: string, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailQueueName' is not null or undefined
            assertParamExists('mailQueueControllerGetQueuedMails', 'mailQueueName', mailQueueName)
            const localVarPath = `/api/mpa/mailqueue/getQueuedMails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailQueueName !== undefined) {
                localVarQueryParameter['mailQueueName'] = mailQueueName;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MPAMailQueueApi - functional programming interface
 * @export
 */
export const MPAMailQueueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MPAMailQueueApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} mailQueueName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailQueueControllerDeleteAllQueuedMail(mailQueueName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailQueueControllerDeleteAllQueuedMail(mailQueueName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailQueueApi.mailQueueControllerDeleteAllQueuedMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {MailQueueField} field 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailQueueControllerDeleteQueuedMail(mailQueueName: string, field: MailQueueField, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailQueueControllerDeleteQueuedMail(mailQueueName, field, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailQueueApi.mailQueueControllerDeleteQueuedMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailQueueControllerDeleteQueuedMails(mailQueueName: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailQueueControllerDeleteQueuedMails(mailQueueName, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailQueueApi.mailQueueControllerDeleteQueuedMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailQueueControllerGetQueueNames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailQueueControllerGetQueueNames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailQueueApi.mailQueueControllerGetQueueNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailQueueControllerGetQueueSize(mailQueueName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailQueueControllerGetQueueSize(mailQueueName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailQueueApi.mailQueueControllerGetQueueSize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {string} mailName 
         * @param {boolean} [includeMIME] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailQueueControllerGetQueuedMail(mailQueueName: string, mailName: string, includeMIME?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailDetailsWithMIME>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailQueueControllerGetQueuedMail(mailQueueName, mailName, includeMIME, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailQueueApi.mailQueueControllerGetQueuedMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailQueueControllerGetQueuedMails(mailQueueName: string, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MailDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailQueueControllerGetQueuedMails(mailQueueName, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailQueueApi.mailQueueControllerGetQueuedMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MPAMailQueueApi - factory interface
 * @export
 */
export const MPAMailQueueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MPAMailQueueApiFp(configuration)
    return {
        /**
         * 
         * @param {string} mailQueueName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerDeleteAllQueuedMail(mailQueueName: string, options?: any): AxiosPromise<number> {
            return localVarFp.mailQueueControllerDeleteAllQueuedMail(mailQueueName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {MailQueueField} field 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerDeleteQueuedMail(mailQueueName: string, field: MailQueueField, value: string, options?: any): AxiosPromise<number> {
            return localVarFp.mailQueueControllerDeleteQueuedMail(mailQueueName, field, value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerDeleteQueuedMails(mailQueueName: string, requestBody: Array<string>, options?: any): AxiosPromise<number> {
            return localVarFp.mailQueueControllerDeleteQueuedMails(mailQueueName, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueueNames(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.mailQueueControllerGetQueueNames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueueSize(mailQueueName: string, options?: any): AxiosPromise<number> {
            return localVarFp.mailQueueControllerGetQueueSize(mailQueueName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {string} mailName 
         * @param {boolean} [includeMIME] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueuedMail(mailQueueName: string, mailName: string, includeMIME?: boolean, options?: any): AxiosPromise<MailDetailsWithMIME> {
            return localVarFp.mailQueueControllerGetQueuedMail(mailQueueName, mailName, includeMIME, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailQueueName 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailQueueControllerGetQueuedMails(mailQueueName: string, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<MailDetails>> {
            return localVarFp.mailQueueControllerGetQueuedMails(mailQueueName, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MPAMailQueueApi - object-oriented interface
 * @export
 * @class MPAMailQueueApi
 * @extends {BaseAPI}
 */
export class MPAMailQueueApi extends BaseAPI {
    /**
     * 
     * @param {string} mailQueueName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailQueueApi
     */
    public mailQueueControllerDeleteAllQueuedMail(mailQueueName: string, options?: RawAxiosRequestConfig) {
        return MPAMailQueueApiFp(this.configuration).mailQueueControllerDeleteAllQueuedMail(mailQueueName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailQueueName 
     * @param {MailQueueField} field 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailQueueApi
     */
    public mailQueueControllerDeleteQueuedMail(mailQueueName: string, field: MailQueueField, value: string, options?: RawAxiosRequestConfig) {
        return MPAMailQueueApiFp(this.configuration).mailQueueControllerDeleteQueuedMail(mailQueueName, field, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailQueueName 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailQueueApi
     */
    public mailQueueControllerDeleteQueuedMails(mailQueueName: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return MPAMailQueueApiFp(this.configuration).mailQueueControllerDeleteQueuedMails(mailQueueName, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailQueueApi
     */
    public mailQueueControllerGetQueueNames(options?: RawAxiosRequestConfig) {
        return MPAMailQueueApiFp(this.configuration).mailQueueControllerGetQueueNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailQueueName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailQueueApi
     */
    public mailQueueControllerGetQueueSize(mailQueueName: string, options?: RawAxiosRequestConfig) {
        return MPAMailQueueApiFp(this.configuration).mailQueueControllerGetQueueSize(mailQueueName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailQueueName 
     * @param {string} mailName 
     * @param {boolean} [includeMIME] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailQueueApi
     */
    public mailQueueControllerGetQueuedMail(mailQueueName: string, mailName: string, includeMIME?: boolean, options?: RawAxiosRequestConfig) {
        return MPAMailQueueApiFp(this.configuration).mailQueueControllerGetQueuedMail(mailQueueName, mailName, includeMIME, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailQueueName 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailQueueApi
     */
    public mailQueueControllerGetQueuedMails(mailQueueName: string, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return MPAMailQueueApiFp(this.configuration).mailQueueControllerGetQueuedMails(mailQueueName, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }
}

